import { render, staticRenderFns } from "./study-features-header.vue?vue&type=template&id=e7e8327e&scoped=true&"
import script from "./study-features-header.vue?vue&type=script&lang=js&"
export * from "./study-features-header.vue?vue&type=script&lang=js&"
import style0 from "./study-features-header.vue?vue&type=style&index=0&id=e7e8327e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e8327e",
  null
  
)

component.options.__file = "study-features-header.vue"
export default component.exports